import script from "./CommonConfig.vue?vue&type=script&lang=js"
export * from "./CommonConfig.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__